import React from "react";
import { CoaDetailRow } from "../helpers/ipInventory.types";

interface CoaDetailsTableProps {
  coaList: CoaDetailRow[];
  onCoaChange: (index: number, col: "coaInfo" | "labelInfo", value: "yes" | "no" | "na") => void;
  isDisabled?: boolean;
}

const CoaDetailsTable: React.FC<CoaDetailsTableProps> = ({
  coaList,
  onCoaChange,
  isDisabled = false,
}) => {
  const sectionDividerStyle = { borderRight: "1px solid #94a3b8" };

  return (
    <div className="table-responsive border rounded-3 overflow-hidden shadow-sm">
      <table className="table table-bordered table-sm align-middle text-center mb-0" style={{ fontSize: "12px" }}>
        <thead>
          <tr className="bg-light text-dark fw-bold">
            <th rowSpan={2} style={{ width: "60px", backgroundColor: "#f3f6f9" }} className="align-middle border-end">
              Sr. No.
            </th>
            <th rowSpan={2} style={{ backgroundColor: "#f3f6f9", ...sectionDividerStyle }} className="text-start align-middle">
              Particulars
            </th>
            <th colSpan={3} style={{ backgroundColor: "#eef2f7", ...sectionDividerStyle }} className="text-primary text-center py-2">
              COA Information Provided in COA
            </th>
            <th colSpan={3} style={{ backgroundColor: "#eef2f7" }} className="text-primary text-center py-2">
              Label Information Provided in Label
            </th>
          </tr>
          <tr className="bg-light">
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              Yes
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              No
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa", ...sectionDividerStyle }} className="py-1">
              N/A
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              Yes
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              No
            </th>
            <th style={{ width: "90px", minWidth: "90px", backgroundColor: "#f8f9fa" }} className="py-1">
              N/A
            </th>
          </tr>
        </thead>
        <tbody>
          {coaList.map((item, idx) => (
            <tr key={item.coaid || idx} className="hover-row">
              <td className="fw-semibold text-muted text-center">{idx + 1}</td>
              <td className="text-start fw-medium px-3" style={sectionDividerStyle}>
                {item.particulars}
              </td>
              {/* COA Info Radio Group */}
              {(["yes", "no", "na"] as const).map((val) => (
                <td
                  key={`coa_${val}`}
                  className="text-center"
                  style={val === "na" ? sectionDividerStyle : undefined}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <input
                      type="radio"
                      className="form-check-input my-0 cursor-pointer"
                      name={`coa_info_${idx}`}
                      checked={item.coaInfo === val}
                      onChange={() => onCoaChange(idx, "coaInfo", val)}
                      disabled={isDisabled}
                    />
                  </div>
                </td>
              ))}
              {/* Label Info Radio Group */}
              {(["yes", "no", "na"] as const).map((val) => (
                <td key={`label_${val}`} className="text-center">
                  <div className="d-flex align-items-center justify-content-center">
                    <input
                      type="radio"
                      className="form-check-input my-0 cursor-pointer"
                      name={`label_info_${idx}`}
                      checked={item.labelInfo === val}
                      onChange={() => onCoaChange(idx, "labelInfo", val)}
                      disabled={isDisabled}
                    />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CoaDetailsTable;
